export default "__VITE_ASSET__DmloQuBp__"